
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      overlay: true,
      productSelected: {},
      singleValidity: [],
      getProducts: [],
      valueValiditySelected: '',
    }
  },

  computed: {
    ...mapGetters('product-open', [
      'filterOneCategory',
      'allProducts',
      'allCategorias',
    ]),
    ...mapGetters('unidade', ['unidadeInformation']),

    categorySelected() {
      const category = this.$route.params.nome.toLowerCase()
      const x = this.filterOneCategory(category)
      return x
    },

    filteredProducts() {
      const validadeProdutoId = this.valueValiditySelected
      return this.getProducts.filter(
        (item) => item.tipoProduto === validadeProdutoId
      )
    },

    imgNotrenderMobile() {
      return this.$vuetify.breakpoint.width >= 768
    },
  },

  async mounted() {
    await this.fetchCategoryIfNeeded()
    await this.loadProduct()
  },

  methods: {
    ...mapActions('product-open', ['fetchProdutoOpen', 'fetchCategoriaOpen']),
    ...mapActions('cart', ['adicionarCart']),

    purchase() {
      this.adicionarCart(this.productSelected)
      this.$router.push('/compra-pedido')
    },

    async loadProduct() {
      const unidade = this.unidadeInformation.cpfcnpj
      const devCnpj = '19520630000115'

      const cnpj = !unidade ? devCnpj : unidade
      const nameCategoryRoute = this.$route.params.nome.toLowerCase()
      const categoria = this.filterOneCategory(nameCategoryRoute).id

      try {
        await this.fetchProdutoOpen({ cnpj, categoria })

        const uniqueTipoProduto = [
          ...new Set(this.allProducts.map((product) => product.tipoProduto)),
        ].sort()
        this.singleValidity = uniqueTipoProduto
        this.valueValiditySelected = uniqueTipoProduto[0]

        const productsMap = this.allProducts.map((item) => ({
          ...item,
          nomeVenda: `${this.categorySelected.nome} ${item.nome} ${item.tipoProduto}`,
        }))

        this.getProducts = productsMap
        this.productSelected = this.filteredProducts[0]
      } catch (error) {
        this.$toast.error(error)
        console.error(error)
      } finally {
        this.overlay = false
      }
    },

    async fetchCategoryIfNeeded() {
      if (this.allCategorias.length === 0) {
        try {
          await this.fetchCategoriaOpen()
        } catch (error) {
          console.error(error)
        }
      }
    },

    buttonValidySelected(item) {
      this.valueValiditySelected = item
      this.productSelected = this.filteredProducts[0]
    },
  },
}
